
import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
@Injectable({
    providedIn: 'root'
})

export class AuthGuard implements CanLoad , CanActivate { 

    constructor(
        private router: Router,
        private toastr: ToastrService
    ) { 
    }

    canLoad(): boolean {
        const kycLogin = JSON.parse(sessionStorage.getItem('kycLogin'));
        if(kycLogin !== null){
            return true;
        }

        else {
            this.toastr.error("You are not authorised. Please Login!!!");
            this.router.navigate(['/admin-login']);
        }
    }
    canActivate(): boolean {
        const kycLogin = JSON.parse(sessionStorage.getItem('kycLogin'));
        if(kycLogin !== null){
            return true;
        }

        else {
            this.toastr.error("You are not authorised. Please Login!!!");
            this.router.navigate(['/admin-login']);
        }
    }
}